import { ArrowTopRightIcon } from 'evergreen-ui';
import { AnchorComponent } from '..';
import { ReactComponent as MarkerIcon } from '../../assets/icons/map-marker-alt-light.svg';

export const Directions = ({ address, style }) => (
    <div style={style}>
        <AnchorComponent
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(Object.values(address).join(' '))}`}
            style={{ display: 'block', marginTop: 5, marginBottom: 5 }}
        >
            <MarkerIcon height="16px" color="var(--text)" />
            <span style={{ marginLeft: '5px', marginRight: '10px', fontWeight: '300' }}>
                {Object.values(address).join(', ')}
            </span>
            <ArrowTopRightIcon size={12} marginLeft={5} />
        </AnchorComponent>
    </div>
);
